export const collaborateHero = {
  badge: "Work With TIE",
  title: "Collaborate With Us",
  subtitle:
    "Whether you are a factory seeking innovation, a technology partner looking for collaborators, a researcher with applied questions, or a brand wanting verified supply chain partners - TIE has a collaboration pathway for you.",
  ctaPrimary: "Submit an Enquiry",
  ctaSecondary: "Explore Options",
};

export const collaborateWays = [
  {
    type: "Factory",
    title: "Factory Partnership",
    description:
      "Enrol your factory in PIIC, PTIM, or Training programmes. Get embedded Innovation Circles, expert guidance, and evidence-backed transformation.",
    icon: "ri-building-line",
    programmes: ["PIIC", "PTIM", "FSD / PSD / Black Belt", "TIE Experts Platform"],
  },
  {
    type: "Technology Partner",
    title: "Technology Partner",
    description:
      "Showcase your technology, chemical, or automation solution to Bangladesh's leading textile factories through the Expo, pilot programmes, and direct matchmaking.",
    icon: "ri-lightbulb-flash-line",
    programmes: ["Textile Innovation Expo", "Pilot Partnerships", "Technology Matchmaking"],
  },
  {
    type: "Research",
    title: "Research Collaboration",
    description:
      "Partner on applied research through PIARC, contribute to IJTAI, or present at AIRCon. Bridge academic knowledge with factory floor reality.",
    icon: "ri-microscope-line",
    programmes: ["PIARC", "IJTAI", "AIRCon", "Research Grants"],
  },
  {
    type: "Academic",
    title: "Academic Partnership",
    description:
      "Connect your university or research institute with factory-led applied research. Co-supervise students, publish findings, and build sector knowledge.",
    icon: "ri-graduation-cap-line",
    programmes: ["Student Placements", "Joint Research", "Curriculum Development"],
  },
  {
    type: "Buyer",
    title: "Brand / Buyer Partnership",
    description:
      "Source from TIE-certified factories. Access verified innovation readiness scores, sustainability metrics, and transparent supply chain data.",
    icon: "ri-shopping-bag-line",
    programmes: ["Innovation Readiness Index", "Factory Certification", "Supply Chain Transparency"],
  },
  {
    type: "Sponsor",
    title: "Event Sponsorship",
    description:
      "Sponsor the Textile Innovation Expo, AIRCon, or the Innovation Awards. Reach 5,000+ factory delegates, researchers, and industry decision-makers.",
    icon: "ri-vip-crown-line",
    programmes: ["Expo Sponsorship", "AIRCon Partnership", "Awards Programme"],
  },
];

export const collaborateProcess = [
  {
    step: "01",
    title: "Enquire",
    description:
      "Submit your collaboration enquiry through the form below. Tell us who you are, what you need, and what success looks like.",
    icon: "ri-edit-line",
  },
  {
    step: "02",
    title: "Assess",
    description:
      "TIE's team reviews your enquiry within 48 hours. We schedule a discovery call to understand your context, constraints, and goals.",
    icon: "ri-search-line",
  },
  {
    step: "03",
    title: "Design",
    description:
      "We co-design a collaboration plan - programme selection, timeline, resource needs, and success metrics tailored to your situation.",
    icon: "ri-pencil-ruler-2-line",
  },
  {
    step: "04",
    title: "Deploy",
    description:
      "The programme launches. TIE provides facilitation, expert access, and continuous support. You get regular progress updates and evidence documentation.",
    icon: "ri-rocket-line",
  },
];

export const collaborateTrust = {
  stats: [
    { value: "48h", label: "Response Time", sub: "on all enquiries" },
    { value: "80+", label: "Factory Partners", sub: "across Bangladesh" },
    { value: "150+", label: "Expert Associates", sub: "30+ specializations" },
    { value: "250+", label: "Projects Deployed", sub: "since 2018" },
  ],
  quote: {
    text: "TIE's PIIC programme transformed how we approach problem-solving on the factory floor. The Innovation Circles are now part of our daily operations.",
    author: "Factory Partner",
    company: "Bangladesh Textile Industry",
  },
};